import MiniProgram from "@/assets/icons/profile/mini-program";
import { IconWrapper } from "@/pages/profile/components/atom";

export function BindMiniProgramIcon() {
  return (
    <IconWrapper>
      <MiniProgram />
    </IconWrapper>
  );
}
